import React from "react";
import { Card } from "../card";
import { GridWrapper } from "../GridWrapper/GridWrapper";
import { AddTransport } from "./AddTransport";
import { TransportList } from "./TransportList";

export const TransportsComponent = () => {
  return (
    <GridWrapper
      totalColumns={3}
      childrens={[
        {
          component: (
            <Card wrapperStyle={{ height: "100%" }} cardTitle="Add transport">
              <div>
                <AddTransport />
              </div>
            </Card>
          ),
          gridSpan: 1,
        },
        {
          component: (
            <Card
              wrapperStyle={{
                height: "100%",
              }}
              cardTitle="All transports"
            >
              <div>
                <TransportList />
              </div>
            </Card>
          ),
          gridSpan: 2,
        },
      ]}
    />
  );
};
